export const SettingsIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs />
      <rect x={0.5} y={0.501} width={23} height={23} rx={4} fill="#00e6ca" />
      <path d="M12,.5H4.5a4,4,0,0,0-4,4v15a4,4,0,0,0,4,4H12Z" fill="#c4f0eb" />
      <rect
        x={0.5}
        y={0.501}
        width={23}
        height={23}
        rx={4}
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.071,13.985l-.684-.394a5.438,5.438,0,0,0,0-2.179l.685-.4a1,1,0,0,0,.366-1.366l-.75-1.3a1,1,0,0,0-1.366-.366l-.684.394a5.508,5.508,0,0,0-1.888-1.092V6.5a1,1,0,0,0-1-1h-1.5a1,1,0,0,0-1,1V7.3A5.454,5.454,0,0,0,8.364,8.381l-.685-.4a1,1,0,0,0-1.366.366l-.75,1.3a1,1,0,0,0,.365,1.366l.684.4a5.451,5.451,0,0,0,0,2.178l-.685.395a1,1,0,0,0-.366,1.367l.75,1.3a1,1,0,0,0,1.366.366l.684-.395a5.542,5.542,0,0,0,1.886,1.092V18.5a1,1,0,0,0,1,1h1.5a1,1,0,0,0,1-1v-.793a5.458,5.458,0,0,0,1.886-1.087l.686.4a1,1,0,0,0,1.366-.366l.75-1.3A1,1,0,0,0,18.071,13.985ZM12,15a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,12,15Z"
        fill="#c4f0eb"
      />
      <path
        d="M5.928,11.017l.684.4a5.451,5.451,0,0,0,0,2.178l-.685.395a1,1,0,0,0-.366,1.367l.75,1.3a1,1,0,0,0,1.054.482l2.865-2.864a2.5,2.5,0,1,1,3.535-3.536L16.63,7.87a.989.989,0,0,0-.309.116l-.684.394a5.508,5.508,0,0,0-1.888-1.092V6.5a1,1,0,0,0-1-1h-1.5a1,1,0,0,0-1,1V7.3A5.454,5.454,0,0,0,8.364,8.381l-.685-.4a1,1,0,0,0-1.366.366l-.75,1.3A1,1,0,0,0,5.928,11.017Z"
        fill="#f8fafc"
      />
      <path
        d="M18.071,13.985l-.684-.394a5.438,5.438,0,0,0,0-2.179l.685-.4a1,1,0,0,0,.366-1.366l-.75-1.3a1,1,0,0,0-1.366-.366l-.684.394a5.508,5.508,0,0,0-1.888-1.092V6.5a1,1,0,0,0-1-1h-1.5a1,1,0,0,0-1,1V7.3A5.454,5.454,0,0,0,8.364,8.381l-.685-.4a1,1,0,0,0-1.366.366l-.75,1.3a1,1,0,0,0,.365,1.366l.684.4a5.451,5.451,0,0,0,0,2.178l-.685.395a1,1,0,0,0-.366,1.367l.75,1.3a1,1,0,0,0,1.366.366l.684-.395a5.542,5.542,0,0,0,1.886,1.092V18.5a1,1,0,0,0,1,1h1.5a1,1,0,0,0,1-1v-.793a5.458,5.458,0,0,0,1.886-1.087l.686.4a1,1,0,0,0,1.366-.366l.75-1.3A1,1,0,0,0,18.071,13.985ZM12,15a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,12,15Z"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
